import React from 'react';
export default function PrivacyPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-16 prose prose-slate">
      <h1 className="font-display text-3xl font-semibold">Privacy policy</h1>
      <p className="text-sm text-muted-foreground">Effective date: {new Date().toISOString().slice(0,10)}</p>
      <div className="mt-6 space-y-4 text-sm">
        <p>Aakash Drishti (“we”, “our”) is committed to protecting personal information collected while providing the enterprise satellite intelligence platform.</p>
        <h3 className="font-semibold">Data we collect</h3>
        <p>Contact details submitted through demo/contact forms; account information provided by authorised administrators; usage telemetry for system reliability.</p>
        <h3 className="font-semibold">How we use it</h3>
        <p>Delivering and improving the service, communicating operational matters, and complying with legal obligations. We do not sell personal information.</p>
        <h3 className="font-semibold">Data residency</h3>
        <p>Enterprise customers may choose data residency during onboarding.</p>
      </div>
    </div>
  );
}
